import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const GoogleCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setAuthData } = useAuth();
  const [error, setError] = useState('');
  const exchangeStartedRef = useRef(false);

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state') || '';
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError('Connexion Google annulée');
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    if (!code) {
      setError('Code d\'autorisation manquant');
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    if (exchangeStartedRef.current) return;
    exchangeStartedRef.current = true;

    const exchangeCode = async () => {
      try {
        const res = await axios.post(`${API_URL}/api/auth/google/callback`, { code, state });
        const { access_token, user } = res.data;
        setAuthData(access_token, user);
        toast.success(`Bienvenue, ${user.name} !`);
        navigate('/');
      } catch (err) {
        setError(err.response?.data?.detail || 'Erreur de connexion Google');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    exchangeCode();
  }, [searchParams, navigate, setAuthData]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center">
      {error ? (
        <div className="text-center">
          <p className="text-destructive text-lg mb-2">{error}</p>
          <p className="text-muted-foreground text-sm">Redirection vers la page de connexion...</p>
        </div>
      ) : (
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4 text-[#D62828]" />
          <p className="text-lg font-medium">Connexion avec Google en cours...</p>
          <p className="text-muted-foreground text-sm mt-1">Veuillez patienter</p>
        </div>
      )}
    </div>
  );
};

export default GoogleCallbackPage;
